import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const GolfIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.5 1.7C7.5 1.3134 7.8134 1 8.2 1H8.3C8.6866 1 9 1.3134 9 1.7V11.0277C11.8377 11.1863 14 12.009 14 13C14 14.1046 11.3137 15 8 15C4.68629 15 2 14.1046 2 13C2 12.2579 3.21237 11.6103 5.01286 11.2651C5.5348 11.165 6 11.5808 6 12.1123V12.25C6 12.6642 6.33579 13 6.75 13C7.16421 13 7.5 12.6642 7.5 12.25V1.7Z"
		></path>
		<path
			fill="currentColor"
			d="M10 5.79052V1.20948C10 1.0573 10.1153 0.956026 10.2168 1.019L13.9101 3.30952C14.03 3.38385 14.03 3.61615 13.9101 3.69048L10.2168 5.981C10.1153 6.04397 10 5.9427 10 5.79052Z"
		></path>
	</svg>
))
